var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconListing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.46 283.46",
    style: {
      enableBackground: "new 0 0 283.46 283.46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 11,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M178.701 252.662H84.55c-18.414 0-33.342-15.327-33.342-34.234V49.509c0-9.437 7.451-17.086 16.641-17.086h137.017c18.414 0 33.342 15.327 33.342 34.234v107.08c0 18.906-41.092 78.925-59.507 78.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M76.208 68.596h72M171.542 68.596h38.666M76.208 98.174h72M171.542 98.174h38.666M76.208 127.753h72M171.542 127.753h38.666M76.208 157.332h72M171.542 157.332h38.666M76.208 186.91h72M171.542 186.91h19.333M171.542 216.489h6.666M76.208 216.489h72"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListing);
export default __webpack_public_path__ + "static/media/icon_listing.78b9a9bf06ae000dadb57d8ed4f03d3d.svg";
export { ForwardRef as ReactComponent };